module.exports = __webpack_public_path__ + "img/4-5.9cac7138.svg";